import getTrafficSource from '../url/getTrafficSource';

/**
 * Remove elements that don't match the current traffic source (comma separated)
 *
 * data-traffic="sem" -- If the element should be displayed for SEM traffic only
 * data-traffic="sem,avm" -- If the element should be displayed for SEM/AVM traffic
 */
export default function removeNonMatchingTrafficSourceElements() {
	const currentSource = getTrafficSource() || '';

	document.querySelectorAll('[data-traffic]').forEach(el => {
		const allowedSources = el.dataset.traffic.split(',').map(s => s.trim());
		if (!currentSource || !allowedSources.includes(currentSource)) {
			el.remove();
		}
	});
}